import { render } from "./MarkdownPage.vue?vue&type=template&id=5dbf90f8&scoped=true&ts=true"
import script from "./MarkdownPage.vue?vue&type=script&lang=ts"
export * from "./MarkdownPage.vue?vue&type=script&lang=ts"

import "./MarkdownPage.vue?vue&type=style&index=0&id=5dbf90f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbf90f8"]])

export default __exports__